<nx-headline-box
  class="mt-[1.25rem]"
  [label]="'orderModule.orderRentLineItemsComponent.lineItems' | translate">
</nx-headline-box> 

<div class="mb-2">

  <!-- line items-->
  <div
    class="mb-2 flex flex-row"
    *ngFor="let item of orderLineItems; let i = index">
    <div class="bg-[#EAEEEF] px-5 border-b border-gray text-lg font-medium leading-4 flex flex-col pt-[1.188em] w-[62px]">
      {{i + 1}}
    </div>
    <div class="flex-grow">
      <!-- line item -->
      <nx-default-box class="bg-white border-b border-gray"
        [label]="item.text">
          {{item?.startDateTime | date:'dd.MM.yyyy HH:mm'}}&nbsp; - &nbsp; {{item?.endDateTime| date:'dd.MM.yyyy HH:mm'}}
      </nx-default-box>

      <!-- resource assignments -->
      <div
        *ngFor="let resourceAssignment of item?.resourceAssignments; let isFirst = first" 
        class="assignments"
        [ngClass]="{'mt-2': !isFirst}">
        <!-- resource assignment -->
        <nx-default-box
          [menuItems]="getAvailableMenuItems(resourceAssignment)"
          class="border-b border-l border-gray bg-[#EAEEEF]"
          icon="icon-item"
          [label]="resourceAssignment?.resource?.text">
        <ng-container chips>
          <ng-template nxTemplate="tag">
            <p-tag [value]="resourceAssignment?.getResourceAssignmentState() | translate" [severity]="resourceAssignment?.getResourceAssignmentStateSeverity()"></p-tag>
          </ng-template>
        </ng-container>
        <ng-container label>
          <a [routerLink]="['/resources/resource/', resourceAssignment?.resource?.id ]" class="jump ">
            {{resourceAssignment?.resource?.text}}
            <i [className]="'icon icon-jump-to'"></i>
          </a>
        </ng-container>
          {{resourceAssignment?.startDateTime | date:'dd.MM.yyyy HH:mm'}} - {{resourceAssignment?.endDateTime | date:'dd.MM.yyyy HH:mm'}}
        </nx-default-box>

        <!-- handling -->
        <div class="flex flex-row">

          <!-- out handling -->
          <nx-default-box class="bg-white basis-full border-b border-gray"
            [label]="'orderModule.orderRentLineItemsComponent.isAvailable' | translate">
            {{(resourceAssignment?.free === true ? 'orderModule.orderRentLineItemsComponent.yes' : 'orderModule.orderRentLineItemsComponent.no') | translate}}
          </nx-default-box>

        </div>  

        <!-- handling -->
        <div class="flex flex-row">

          <!-- out handling -->
          <nx-default-box class="bg-white basis-1/2 border-b border-r border-gray"
            [label]="(this.getHandlingType(resourceAssignment?.effectiveSchedulingInformation?.outHandlingType?.toString(), 'out') | translate) + ' (' + ('orderModule.orderRentLineItemsComponent.handover' | translate) + ')'">
            {{resourceAssignment?.effectiveSchedulingInformation?.outDateTimePeriod?.getDatePeriod(datePipe)}}
          </nx-default-box>

          <!-- in handling -->
          <nx-default-box class="bg-white basis-1/2 border-b border-gray"
            [label]="(this.getHandlingType(resourceAssignment?.effectiveSchedulingInformation?.inHandlingType?.toString(), 'in') | translate) + ' (' + ('orderModule.orderRentLineItemsComponent.return' | translate) + ')'">
            {{ resourceAssignment?.effectiveSchedulingInformation?.inDateTimePeriod?.getDatePeriod(datePipe)}}
          </nx-default-box>
        </div>

        <!-- depo -->
        <div class="flex flex-row">

          <!-- out depot -->
          <nx-default-box class="bg-white basis-1/2 border-b border-r border-gray"
            [label]="'orderModule.orderRentLineItemsComponent.depotHandover' | translate">
            {{ resourceAssignment?.effectiveSchedulingInformation?.outDepot?.label ? resourceAssignment?.effectiveSchedulingInformation?.outDepot?.label : resourceAssignment?.effectiveSchedulingInformation?.outDepot?.name }}
          </nx-default-box>

          <!-- in depot -->
          <nx-default-box class="bg-white basis-1/2 border-b border-gray"
            [label]="'orderModule.orderRentLineItemsComponent.depotReturn' | translate">
            {{ resourceAssignment?.effectiveSchedulingInformation?.inDepot?.label ? resourceAssignment?.effectiveSchedulingInformation?.inDepot?.label : resourceAssignment?.effectiveSchedulingInformation?.inDepot?.name }}
          </nx-default-box>
        </div>

        <!-- address -->
        <div class="flex flex-row">

          <!-- out handling -->
          <nx-default-box class="bg-white basis-1/2 border-b border-r border-gray"
            [label]="'orderModule.orderRentLineItemsComponent.address' | translate">
            <ng-template nxTemplate="tag">
              <app-address-indicator-v2 [size]="'small'" [grade]="resourceAssignment?.effectiveSchedulingInformation?.outAddress?.geocodingResultGrade"></app-address-indicator-v2>
              @if (getAddressNote(resourceAssignment?.effectiveSchedulingInformation?.outAddress); as note ){
                <app-note-icon [note]="note" [floatLeft]="false" class="inline-flex ml-1" />
              }
            </ng-template>
            {{resourceAssignment?.effectiveSchedulingInformation?.outAddress?.getAddressString()}}
          </nx-default-box>

          <!-- in handling -->
          <nx-default-box class="bg-white basis-1/2 border-b border-gray "
            [label]="'orderModule.orderRentLineItemsComponent.address' | translate">
            <ng-template nxTemplate="tag">
              <app-address-indicator-v2 [size]="'small'" [grade]="resourceAssignment?.effectiveSchedulingInformation?.inAddress?.geocodingResultGrade"></app-address-indicator-v2>
              @if (getAddressNote(resourceAssignment?.effectiveSchedulingInformation?.inAddress); as note ){
               <app-note-icon [note]="note" [floatLeft]="false" class="inline-flex ml-1" />
              }
            </ng-template>
            {{resourceAssignment?.effectiveSchedulingInformation?.inAddress?.getAddressString()}}
          </nx-default-box>
        </div>

        <!-- contacts -->
        <div class="flex flex-row">

          <!-- out handling -->
          <nx-default-box class="bg-white basis-1/2 border-b border-r border-gray"
            [label]="'orderModule.orderRentLineItemsComponent.onSiteContact' | translate">
            {{getName(resourceAssignment?.effectiveSchedulingInformation?.onSiteContacts)}} 
          </nx-default-box>

          <!-- in handling -->
          <nx-default-box class="bg-white basis-1/2 border-b border-gray"
            [label]="'orderModule.orderRentLineItemsComponent.onSiteContact' | translate">
            {{getName(resourceAssignment?.effectiveSchedulingInformation?.onSiteContacts)}}
          </nx-default-box>
        </div>

        <!-- tasks -->
        <div 
          class="border-b border-l border-gray bg-[#EAEEEF] px-4 py-2">
          {{ 'orderModule.orderRentLineItemsComponent.tasks.headline' | translate }}
        </div>
        <nx-empty-box
          *ngIf="!resourceAssignment?.protocols || resourceAssignment?.protocols.length === 0"
          [label]="'orderModule.orderRentLineItemsComponent.tasks.emptyMessage' | translate">
        </nx-empty-box>
        <div
          [columns]="defaultColumns"
          *ngFor="let protocol of resourceAssignment?.protocols; let isLast = last"
          task-row-wide
          [showFilesButton]="false"
          [showCommentsButton]="false"
          [showCommandMenu]="false"
          class="bg-white border-gray border-b last:border-none"
          [task]=protocol?.task>
        </div>

      </div>
    </div>
  </div>
</div>

